import React from 'react';
import { makeStyles, LinearProgress, Typography } from '~/lib/bn-material-ui';
import classnames from 'classnames';

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  progressBar: {
    width: '100%',
    borderRadius: '3px',
    height: '0.5rem',
  },
  percent: {
    marginLeft: '0.5rem',
  },
}));

export function BnProgressBar({ value, ...props }) {
  const styles = useStyles();

  return (
    <div {...props} className={classnames(styles.container, props.className)}>
      {value === undefined
        ? <LinearProgress />
        : <>
          <LinearProgress className={styles.progressBar} variant='determinate' value={value}/>
          <Typography className={styles.percent} variant='body2' color='text.secondary'>{`${Math.round(value)}%`}</Typography>
        </>}
    </div>
  );
}
